import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, ArrowUpRight } from "lucide-react";
import { BUSINESS } from "../config";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative bg-[#050505] border-t border-[var(--border-dim)] pt-20 pb-8">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10">
        <div className="grid md:grid-cols-2 gap-12 pb-16 border-b border-[var(--border-dim)]">
          <div>
            <h2 className="font-display text-5xl md:text-7xl font-black uppercase tracking-tighter leading-[0.9]">Ready to<br />clear out?</h2>
            <button onClick={() => document.querySelector("#bid")?.scrollIntoView({ behavior: "smooth" })} data-testid="footer-bid-btn" className="mt-8 inline-flex items-center gap-2 btn-wipe bg-[var(--accent)] text-white hover:text-white px-8 py-4 font-mono text-sm uppercase tracking-widest font-bold">
              Get your bid <ArrowUpRight size={16} />
            </button>
          </div>
          <div className="flex flex-col md:items-end justify-end gap-3">
            <a href={`tel:${BUSINESS.phoneRaw}`} className="inline-flex items-center gap-3 font-display text-3xl md:text-4xl font-bold hover:text-[var(--accent)] transition-colors"><Phone size={24} /> {BUSINESS.phone}</a>
            <a href={`mailto:${BUSINESS.email}`} className="inline-flex items-center gap-2 font-mono text-sm text-[var(--text-secondary)] hover:text-white transition-colors"><Mail size={14} /> {BUSINESS.email}</a>
            <p className="font-mono text-sm text-[var(--text-secondary)] mt-2">{BUSINESS.serviceArea}</p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8 font-mono text-xs uppercase tracking-widest text-[var(--text-secondary)]">
          <span>© {new Date().getFullYear()} {BUSINESS.name} · {BUSINESS.domain}</span>
          <div className="flex items-center gap-6">
            <Link to="/marketplace" className="hover:text-white transition-colors">Marketplace</Link>
            <Link to="/admin" data-testid="footer-admin-link" className="hover:text-white transition-colors">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
